export enum AuroraCirculationPumpStatus {
  ON = 1,
  OFF = 0
}

export default AuroraCirculationPumpStatus
